import API from './API';
import Twilio from './Twilio';
import Socket from './Socket';
import Session from './Session';
import Worker from '../Models/Worker';
import {writable} from 'svelte/store';

const content = {globalTimeline: [], list: [], timeline: [], recentContacts: []};
let agent = writable(content);

agent.getSelf = async () => {
	const response = await API.request('get', 'agent');
	if(response.success) {
		content.globalTimeline = response?.globalTimeline
		content.timeline = response?.timeline
		content.recentContacts = response?.recentContacts
		agent.set(content);
	}
}

agent.get = async (id) => {
	const response = await API.request('get', `agent/${id}`);
	if(response.success) {
		// const agent = response.agent;
		// if(agent?.timeline) content.timeline = agent.timeline;
		// if(agent?.initials) content.initials = agent.initials;
		// if(agent?.name) content.name = agent.name;
		// agent.set(content);
	}
	return response;
}

agent.list = async () => {
	const response = await API.request('get', 'agent/list', {}, false);
	if(response.success)
		content.list = response.agents;

	agent.set(content);
}

agent.setWorker = async () => {
	try {
		const worker = new Worker();
		const subscription = await worker.init();
		if(subscription)
			await API.request('post', 'agent/notification/register', { notification: subscription }, false);
	} catch (error) {
		console.error(error);
	}
}

agent.testNotification = async () => {
	try {
		const id = Session.getId();
		if(id)
			await API.request('post', 'agent/notification/test', { id }, false);
	} catch (error) {
		console.error(error);
	}
}

agent.logout = async () => {
	try {
		const worker = new Worker();
		API.signOut();
		await worker.unRegisterServiceWorker();
		Socket.close();
	} catch (error) {
		console.error(error);
	}
}

agent.init = async () => {
	Socket.init();
	await Twilio.init()
	await agent.list();
	await agent.setWorker();
}

export default agent;